import { render, staticRenderFns } from "./SkeletonBox.vue?vue&type=template&id=7f22f3f6&"
import script from "./SkeletonBox.vue?vue&type=script&lang=ts&"
export * from "./SkeletonBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports